import { Tag, Tooltip } from 'antd';
import moment from 'moment';
import { truncateString } from '@/utils/utils';

const mapping = {
  AWS: {
    'EC2:Instance': {
      Tags: {
        name: 'Tags',
        valueHandler: value => {
          const renderVal = value.map(val => {
            const tagString = `${val.Key}: ${val.Value}`;
            return (
              <Tooltip title={tagString} key={val.Key}>
                {truncateString(tagString, 30)}
              </Tooltip>
            );
          });
          return renderVal;
        },
      },
      InstanceId: {
        name: 'Instance ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      State: {
        name: 'Instance State',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value.Name}</>;
        },
      },
      InstanceType: {
        name: 'Instance Type',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      PublicDnsName: {
        name: 'Public IP',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      PrivateIpAddress: {
        name: 'Private IP',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      SecurityGroups: {
        name: 'Security Groups',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value[0].GroupId}</>;
        },
      },
      SubnetId: {
        name: 'Subnet ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      VolumeId: {
        name: 'EBS ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      InstanceRAM: {
        name: 'Instance RAM',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      VpcId: {
        name: 'VPC ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      AvailabilityZone: {
        name: 'Availability Zone',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      Region: {
        name: 'Region',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },
    'EC2:AMI': {
      Tags: {
        name: 'Tags',
        valueHandler: value => {
          const renderVal = value.map(val => {
            const tagString = `${val.Key}: ${val.Value}`;
            return (
              <Tooltip title={tagString} key={val.Key}>
                {truncateString(tagString, 30)}
              </Tooltip>
            );
          });
          return renderVal;
        },
      },
      ImageId: {
        name: 'Image ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      Public: {
        name: 'Public',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value === true ? 'Yes' : 'No'}</>;
        },
      },
      Description: {
        name: 'Description',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      Architecture: {
        name: 'Architecture',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      OwnerId: {
        name: 'Owner ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      PlatformDetails: {
        name: 'Platform Details',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },
    'EC2:Volume': {
      VolumeId: {
        name: 'Volume ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      VolumeType: {
        name: 'Volume Type',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      Encrypted: {
        name: 'Encryption',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{JSON.stringify(value)}</>;
        },
      },
      KmsKeyId: {
        name: 'KMS Key ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      KmsKeyArn: {
        name: 'KMS Key ARN',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      AvailabilityZone: {
        name: 'Availability Zone',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },
    'EC2:ElasticIP': {
      Type: {
        name: 'Type',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>Public IP</>;
        },
      },
      AllocationId: {
        name: 'Allocation ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      AssociationId: {
        name: 'Association ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      PrivateIpAddress: {
        name: 'Private IP Address',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      NetworkInterfaceOwnerId: {
        name: 'Network Interface OwnerID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      NetworkBorderGroup: {
        name: 'Network Border Group',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      AllocatedIpv4Address: {
        name: 'Allocated Ipv4 Address',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },
    'EC2:SecurityGroups': {
      GroupName: {
        name: 'Security Group Name',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      GroupId: {
        name: 'Security Group ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          //
          return <>{value}</>;
        },
      },
      VpcId: {
        name: 'VPC ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          //
          return <>{value}</>;
        },
      },
      OwnerId: {
        name: 'Owner ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          //
          return <>{value}</>;
        },
      },
      IpPermissions: {
        name: 'Inbound Rules Count',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          //
          return <>{value?.length}</>;
        },
      },
      IpPermissionsEgress: {
        name: 'Outbound Rules Count',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          //
          return <>{value?.length}</>;
        },
      },
    },
    S3: {
      BucketName: {
        name: 'SBucket Name',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      Region: {
        name: 'Region',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      TotalBucketSize: {
        name: 'Total Bucket Size',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      TotalNumberOfObjects: {
        name: 'Total Number Of Objects',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      Arn: {
        name: 'ARN',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      StorageClass: {
        name: 'Storage Class',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      StaticWebsiteHosting: {
        name: 'Static Website Hosting',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },
    RDS: {
      Endpoint: {
        name: 'Endpoint',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{{ ['Endpoint']: value.Address, ['Port']: value.Port }}</>;
        },
      },
      DBSubnetGroup: {
        name: 'DBSubnetGroup',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return (
            <>
              {{ ['Subnets']: value.Subnets.map(v => v.SubnetIdentifier), ['VPC ID']: value.VpcId }}
            </>
          );
        },
      },
      AvailabilityZone: {
        name: 'Availability Zone',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      PubliclyAccessible: {
        name: 'Public Accessibility',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{JSON.stringify(value)}</>;
        },
      },
      VpcSecurityGroups: {
        name: 'VPC Security Groups',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{`${value[0].VpcSecurityGroupId} (${value[0].Status})`}</>;
        },
      },
    },
    LAMBDA: {
      FunctionName: {
        name: 'Function Name',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      FunctionArn: {
        name: 'Function ARN',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      Region: {
        name: 'Region',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      LastModified: {
        name: 'Last Modified',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{moment(new Date(value)).fromNow()}</>;
        },
      },
      Version: {
        name: 'Version',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      MemorySize: {
        name: 'Memory (MB)',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      Timeout: {
        name: 'Timeout (sec)',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },
  },
  AZURE: {
    VM: {
      name: {
        name: 'Computer Name',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      hardwareProfile: {
        name: 'Size (Instance Type)',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value.vmSize}</>;
        },
      },
      storageProfile: {
        name: 'StorageProfile',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return (
            <>
              {{
                ['OS Disk Size (GB)']: value?.osDisk?.diskSizeGB,
                ['Data Disk Size (GB)']: value?.dataDisks[0]?.diskSizeGB,
              }}
            </>
          );
        },
      },

      id: {
        name: 'Resource ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },
    SQLSVR: {
      id: {
        name: 'Resource ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      location: {
        name: 'Region',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      version: {
        name: 'Version',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      administratorLogin: {
        name: 'Master User Name',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },

    SA: {
      name: {
        name: 'Storage Account Name',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      id: {
        name: 'Resource ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      statusOfPrimary: {
        name: 'Primary Status',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      statusOfSecondary: {
        name: 'Secondary Status',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      location: {
        name: 'Region',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      // tags: {
      //   name: 'Tags',
      //   /**
      //    * Return JSX or HTML value of the given propertie
      //    * @param {*} value given value, can be either string, array or object
      //    * @returns JSX
      //    */
      //   valueHandler: value => {
      //
      //     return <>{value}</>;
      //   },
      // },
    },
  },
  GCP: {
    Instance: {
      id: {
        name: 'Instance ID',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      machineType: {
        name: 'Machine Type',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      zone: {
        name: 'Zone',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          let region = /[^/]*$/.exec(value)[0];

          return <>{region}</>;
        },
      },
      serviceAccounts: {
        name: 'Service Account',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value[0].email}</>;
        },
      },
      disks: {
        name: 'Disks',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return (
            <>
              {{
                ['Disk Size(GB)']: value[0]?.diskSizeGb,
                ['Disk Type']: value[0]?.guestOsFeatures[0]?.type,
              }}
            </>
          );
        },
      },
    },
    SQL: {
      ipAddresses: {
        name: 'Private IP Address',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value[0].ipAddress}</>;
        },
      },
      memory: {
        name: 'Memory (MB)',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      connectionName: {
        name: 'Connection Name',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
      settings: {
        name: 'Settings',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return (
            <>
              {{
                ['Associated Networking']: value.ipConfiguration.privateNetwork,
                ['SSD Storage (GB)']: value.dataDiskSizeGb,
              }}
            </>
          );
        },
      },
      serviceAccountEmailAddress: {
        name: 'Service Account',
        /**
         * Return JSX or HTML value of the given propertie
         * @param {*} value given value, can be either string, array or object
         * @returns JSX
         */
        valueHandler: value => {
          return <>{value}</>;
        },
      },
    },
  },
};

/**
 * Handle each property depending on its available mapping
 * @param {string} name name of the property
 * @param {*} value given values of the property
 * @returns name and value in object
 */
export const handleProperty = (provider, service, name, value) => {
  let thisPropertyMapping = mapping[provider]?.[service]?.[name];

  if (thisPropertyMapping) {
    if (thisPropertyMapping?.name === 'Tags') {
      // *if there is no mapping for this property, return the name and value as it is
      // ?Tags are array of objects, so we need to handle it differently
      return {
        name: thisPropertyMapping?.name,
        value: thisPropertyMapping?.valueHandler(value),
      };
    } else {
      return {
        name: thisPropertyMapping?.name,
        value: thisPropertyMapping?.valueHandler(value)?.props?.children,
      };
    }
  }
};

// export const resourcePropertiesConfig = {
//   AWS: {
//     'EC2:Instance': [
//       'InstanceId',
//       'State',
//       'InstanceType',
//       'PublicDnsName',
//       'SecurityGroups',
//       'SubnetId',
//       'VolumeId',
//       'InstanceRAM',
//       'VpcId',
//       'AvailabilityZone',
//       'Region',
//     ],
//     'EC2:Volume': [
//       'VolumeId',
//       'VolumeType',
//       'Encrypted',
//       'KmsKeyId',
//       'KmsKeyArn',
//       'AvailabilityZone',
//     ],
//     'EC2:ElasticIP': [
//       'Type',
//       'PublicIp',
//       'AllocationId',
//       'AssociationId',
//       'AllocatedIpv4Address',
//       'PrivateIpAddress',
//       'NetworkInterfaceOwnerId',
//       'IpPermissions',
//       'IpPermissionsEgress',
//       'NetworkBorderGroup',
//     ],
//     'EC2:SecurityGroups': [
//       'GroupName',
//       'GroupId',
//       'VpcId',
//       'OwnerId',
//       'InboundRulesCount',
//       'OutboundRulesCount',
//     ],
//     S3: [
//       'BucketName',
//       'Region',
//       'TotalBucketSize',
//       'TotalNumberOfObjects',
//       'Arn',
//       'StorageClass',
//       'StaticWebsiteHosting',
//     ],
//     RDS: [
//       'Adddress',
//       'Subnets',
//       'Port',
//       'AvailabilityZone',
//       'PubliclyAccessible',
//       'VpcSecurityGroups',
//       'VpcId',
//     ],
//     LAMBDA: [
//       'FunctionName',
//       'FunctionArn',
//       'Region',
//       'LastModified',
//       'Version',
//       'MemorySize',
//       'Timeout',
//     ],
//   },

//   AZURE: {
//     VM: ['name', 'vmSize', 'osDisk', 'dataDisks', 'id', 'ComputerName'],
//     SQLSVR: ['locaion', 'Port', 'id', 'version', 'administratorLogin'],
//     SA: ['name', 'id', 'SubscriptionId', 'tags', 'statusOfPrimary', 'location'],
//   },
//   GCP: {
//     Instance: ['id', 'machineType', 'zone', 'serviceAccounts', 'diskSizeGb', 'disks'],
//     SQL: [
//       'ipAddresses',
//       'Memory',
//       'connectionName',
//       'Logs',
//       'privateNetwork',
//       'serviceAccountEmailAddress',
//       'dataDiskSizeGb',
//     ],
//   },
// };
